// eslint-disable-next-line import/prefer-default-export
export const lsValidations = {
    creditCard: {
        required: true,
        credit_card: true,
    },
    phone: {
        required: true,
        // simple regex to validate between 10-11 digits
        regex: /^\d( ?\d){9,10}$/,
    },
    currency: {
        required: true,
        'ls-currency': true,
    },
    ft: {
        required: true,
        // simple regex to validate positive nonzero numbers
        regex: /^[1-9]\d*$/,
    },
};
